<template>
  <el-dialog :visible="visible" @close="$emit('update:visible', false)" :before-close="beforeClose" class="dialog-w50">
    <h2 class="text-center mt-0">Отображение колонок таблицы заказов</h2>

    <div class="text-secondary mt-3">
      <i class="el-icon-info mr-1" />
      Выбранные галочкой названия столбцов будут отображаться в таблице заказов.
    </div>

    <h3 class="mt-3 mb-3">Выберите столбцы:</h3>
    <el-checkbox class="mb-2" :value="allSelected" @change="onAllSelected" label="">{{allSelected ? 'Отменить все': 'Выбрать все'}}</el-checkbox>

    <div class="column-count-2">
      <el-checkbox-group v-model="showColumns">
        <div v-for="item in allColumns" :key="item.prop" class="py-2">
          <el-checkbox :label="item.prop">{{ item.label }}</el-checkbox>
        </div>
      </el-checkbox-group>
    </div>
    <div class="row mt-4">
      <div class="col-12 col-lg-6 mx-auto mb-3 mb-lg-0">
<!--        <el-button class="w-100" @click="onClear" :disabled="false">Сбросить</el-button>-->
        <el-button class="w-100" @click="$emit('update:visible', false)">Отменить</el-button>
      </div>
      <div class="col-12 col-lg-6 mx-auto">
        <el-button class="w-100" type="primary" @click="onSubmit" :loading="false">Применить</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { ORDER_TABLE_COLUMNS } from '@/commons/constants/ordersTableCols';

export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      showColumns: [],
    };
  },
  computed: {
    ...mapGetters({
      ordersTableColumnsHide: 'orders/ordersTableColumnsHide',
    }),
    allColumns() {
      return ORDER_TABLE_COLUMNS.filter((c) => c.prop !== 'selection');
    },
    allSelected() {
      return this.showColumns.length === this.allColumns.length;
    },
  },
  methods: {
    ...mapActions({
      setOrdersTableHideColumns: 'orders/setOrdersTableHideColumns',
    }),
    beforeClose(done) {
      done();
    },
    fillForm() {
      this.showColumns = this.allColumns.filter((c) => !this.ordersTableColumnsHide.includes(c.prop)).map((c) => c.prop);
    },

    onAllSelected(value) {
      this.showColumns = value ? this.allColumns.map((r) => r.prop) : [];
    },

    onClear() {
      this.fillForm();
    },

    onSubmit() {
      const hideColumns = this.allColumns.filter((c) => !this.showColumns.includes(c.prop)).map((c) => c.prop);
      this.setOrdersTableHideColumns({ hideColumns });
      this.$emit('update:visible', false);
    },
  },
  created() {
    this.fillForm();
  },
};
</script>
